import React, {useState} from 'react';
import {EditOutlined} from '@ant-design/icons';
import {Button, Form, Input, Modal, Popover, Typography} from 'antd';
import _ from 'lodash';

const PaymentChangeButton = ({
                               record,
                               onPaymentChange,
                             }) => {

  const [showModal, setShowModal] = useState(false);
  const [form] = Form.useForm();

  const FORM_CHANGE_PENDING_INVOICE_NUMBER = 'ChangePendingInvoiceNumber';


  const _submit = async () => {
    setShowModal(false);
    onPaymentChange(record.ID, form.getFieldValue(FORM_CHANGE_PENDING_INVOICE_NUMBER));
    form.resetFields();
  };

  const _validateInvoiceNumber = (value) => {
    if (_.isEmpty(value)) {
      return 'Please enter a valid Invoice Number';
    }
    return '';
  }

  return (
    <>
      <Popover
        placement="topRight"
        trigger="hover,click,focus"
        content={
          <Typography>Allows you to try another Invoice Number, to flag that as PAID and link with this
            record.</Typography>
        }>
        <Button onClick={() => setShowModal(true)} disabled={record.status !== 'NOT FOUND'}
                icon={<EditOutlined/>}>
          Change
        </Button>
      </Popover>
      {showModal && (
        <Form
          name={`change${record.pendingInvoiceNumber}${record.ID}`}
          form={form}
          onFinish={_submit}
          labelCol={{span: 9}}
        >
          <Modal
            title={`Change ${record.pendingInvoiceNumber}`}
            open={showModal}
            onOk={() => setShowModal(false)}
            onCancel={() => setShowModal(false)}
            footer={[
              <Button key="cancel" onClick={() => setShowModal(false)}>Cancel</Button>,
              <Button key="submit" type="primary" onClick={() => form.submit()}>Submit</Button>
            ]}
          >

            <Form.Item
              label="Invoice Number"
              name={FORM_CHANGE_PENDING_INVOICE_NUMBER}

              rules={[
                () => ({
                  validator(_, value) {
                    const msg = _validateInvoiceNumber(value);
                    if (msg === '') {
                      return Promise.resolve();
                    } else {
                      return Promise.reject(msg);
                    }
                  }
                })]}
            >
              <Input placeholder="Enter existing Projector invoice number" onInput={e => e.target.value = e.target.value.toUpperCase()}/>
            </Form.Item>
          </Modal>
        </Form>
      )}
    </>
  );
};

export {PaymentChangeButton};